import { OpenImageViewerShell, type OpenImageViewerConfig } from '@/features/open-image-viewer'
import { useT } from '@/shared/i18n'

const PNG_SIGNATURE = [0x89, 0x50, 0x4e, 0x47, 0x0d, 0x0a, 0x1a, 0x0a]

async function hasPngSignature(file: File): Promise<boolean> {
  if (file.size < PNG_SIGNATURE.length) return false

  const bytes = new Uint8Array(await file.slice(0, PNG_SIGNATURE.length).arrayBuffer())
  return PNG_SIGNATURE.every((value, index) => bytes[index] === value)
}

export function PngViewerPage() {
  const t = useT()
  const config: OpenImageViewerConfig = {
    analyticsContext: {
      app: 'imgify',
      domain: 'imgify.ru',
      route: '/otkryt-png',
      utility: 'png-viewer',
      processingMode: 'local',
    },
    accept: '.png,image/png',
    acceptedMimeTypes: ['image/png'],
    acceptedExtensions: ['.png'],
    maxFileSizeBytes: 50 * 1024 * 1024,
    maxPixels: 36_000_000,
    formatLabel: 'PNG',
    previewBackground: 'checkerboard',
    validateFile: hasPngSignature,
    exportFormats: ['jpg'],
    exportNote: t.pngViewer.exportNote,
    convertHref: '/konverter-izobrazheniy',
    acceptedByEditors: true,
    relatedTools: t.pngViewer.relatedTools,
  }

  return <OpenImageViewerShell copy={t.pngViewer} config={config} />
}
